export default {"src":"/_next/static/media/hammer.1b13ead9.svg","height":465,"width":526,"blurWidth":0,"blurHeight":0};